import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EmailNotificationsService } from '../../service/EmailNotificationsService';
import { AuthService } from '../../service/auth.service';

@Component({
  selector: 'app-customer-email-details',
  templateUrl: './customer-email-details.component.html',
  styleUrls: ['./customer-email-details.component.css']
})
export class CustomerEmailDetailsComponent implements OnInit {
  emailNotificationsService = inject(EmailNotificationsService);
  authService = inject(AuthService);
  route = inject(ActivatedRoute);
  router = inject(Router);

  customerNumber = signal<number>(0);
  email = signal<string>('');
  startDate = signal<string>('');
  endDate = signal<string>('');

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.customerNumber.set(+params['customerNumber']);
      this.email.set(params['email']);
      this.startDate.set(params['startDate']);
      this.endDate.set(params['endDate']);

      if (this.customerNumber() && this.email() && this.startDate() && this.endDate()) {
        this.emailNotificationsService.getCustomerEmailDetails(
            this.customerNumber(),
            this.email(),
            this.startDate(),
            this.endDate()
        );
      }
    });
  }
  trackByTransactionId(index: number, item: any) {
    return item.transactionId;
  }

  hasPermission() {
    return this.authService.isSuperAdmin();
  }

  goBack() {
    this.router.navigate(['/app/email-notifications']);
  }

  navigateToTransactionById(transactionId: number) {
    this.router.navigate(['/app/win-ols-transactions', transactionId]);
  }
}
